import { useCart } from '../../context/CartContext';
import { FaTimes, FaShoppingCart, FaFileAlt } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CartItem from './CartItem';
import './CartSidebar.css';

export default function CartSidebar({ isOpen, onClose }) {
  const { items, totalItems, removeItem } = useCart();
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
      setIsOpening(true);
      document.body.style.overflow = 'hidden';
      
      // Desactivar el estado de apertura después de la animación
      setTimeout(() => {
        setIsOpening(false);
      }, 300);
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  };

  const handleQuotation = () => {
    handleClose();
    navigate('/quotation');
  };

  const handleCatalogNavigation = () => {
    handleClose();
    navigate('/catalog');
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className={`modal-backdrop fade show ${isOpening ? 'cart-backdrop-opening' : ''}`}
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1040,
          opacity: isClosing ? 0 : isOpening ? 0 : 1,
          transition: 'opacity 0.3s ease-in-out'
        }}
        onClick={handleClose}
      />

      {/* Sidebar */}
      <div
        className={`position-fixed top-0 end-0 h-100 bg-white shadow ${isOpening ? 'cart-sidebar-opening' : ''}`}
        style={{
          width: '350px',
          zIndex: 1050,
          transform: isClosing ? 'translateX(100%)' : 'translateX(0)',
          transition: 'transform 0.3s ease-in-out'
        }}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="mb-0 d-flex align-items-center">
            <FaShoppingCart className="me-2" />
            Carrito ({totalItems})
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            aria-label="Close"
          />
        </div>

        {/* Body */}
        <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 180px)' }}>
          {items.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0 animate-fade-in">No hay productos en el carrito</p>
              <div className="mt-3 animate-fade-in" style={{ animationDelay: '0.2s' }}>
                <button
                  className="btn btn-primary d-flex align-items-center justify-content-center gap-2 mx-auto catalog-button"
                  onClick={handleCatalogNavigation}
                >
                  <FaShoppingCart />
                  Ver Catálogo
                </button>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column gap-3 p-3">
              {items.map((item) => (
                <CartItem key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="p-3 border-top bg-light">
            <div className="d-grid gap-2">
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={handleQuotation}
              >
                <FaFileAlt />
                Solicitar Cotización
              </button>
              <small className="text-center text-muted">
                Obtenga un presupuesto detallado para su pedido
              </small>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
